export default "__VITE_ASSET__ZptlVq8o__"